// imports
import { FC } from 'react';
// component
import SidebarMain from 'components/common/SidebarMain';
//constants
import { STAFF_MANAGEMENT_LIST } from 'constants/index';

const ManagementList: FC = () => <SidebarMain list={STAFF_MANAGEMENT_LIST} />;

export default ManagementList;
